import { Text, Timestamp } from '@dixa/lib-shared-habla';

import { useConversationRow } from '../../../utils/useConversationRow';

type ConversationsTableTimestampProps = {
  timestampKey: 'created_at' | 'last_message_created_at' | 'queued_at';
};

/** Represents the content of a timestamp cell in the conversations table. */
export const ConversationsTableTimestamp = ({
  timestampKey,
}: ConversationsTableTimestampProps): JSX.Element => {
  const { conversation } = useConversationRow();
  const timestamp = conversation[timestampKey];

  if (!timestamp) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  return (
    <Timestamp
      time={timestamp}
      relative
      onClick={(_format, event) => event.stopPropagation()}
    />
  );
};
